import Link from 'next/link';

export interface BreadcrumbItem {
  label: string;
  href?: string; // undefined means current page (no link)
}

interface BreadcrumbsProps {
  items: BreadcrumbItem[];
  className?: string;
}

export default function Breadcrumbs({ items, className = '' }: BreadcrumbsProps) {
  // Build breadcrumb list with Home prepended
  const fullBreadcrumbs = [
    { label: 'Home', href: '/' },
    ...items
  ];

  // Generate structured data for breadcrumbs (JSON-LD)
  const siteUrl = 'https://inventivehq.com';
  const structuredData = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    'itemListElement': fullBreadcrumbs.map((item, index) => ({
      '@type': 'ListItem',
      'position': index + 1,
      'name': item.label,
      ...(item.href && { 'item': `${siteUrl}${item.href}` })
    }))
  };

  return (
    <>
      {/* Structured Data for SEO */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
      />

      {/* Visual Breadcrumb Navigation */}
      <nav className={`flex flex-wrap items-center gap-x-2 gap-y-1 text-sm mb-6 ${className}`} aria-label="Breadcrumb">
        <Link href="/" className="transition hover:opacity-80">
          Home
        </Link>
        {items.map((item, index) => (
          <div key={index} className="flex items-center gap-x-2 min-w-0">
            <svg className="w-4 h-4 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
            {item.href ? (
              <Link href={item.href} className="transition hover:opacity-80">
                {item.label}
              </Link>
            ) : (
              <span className="font-medium" aria-current="page">{item.label}</span>
            )}
          </div>
        ))}
      </nav>
    </>
  );
}
